module.exports = __webpack_public_path__ + "static/media/logo.bd38b20d.png";